import { type SxProps, type Theme } from "@mui/material";

export const APPLIED_FILTERS_ROOT_SX: SxProps<Theme> = {
  flexWrap: "wrap",
  alignItems: "center",
  gap: 1,
  width: "100%",
};

export const APPLIED_FILTERS_TITLE_SX: SxProps<Theme> = {
  whiteSpace: "nowrap",
  fontWeight: 600,
};
